import { useRef, useEffect } from 'react';

const Navigation = ({data}) => {
    let navOffsetTop = 0;
    const navRef = useRef(null);
    const hamburgerRef = useRef(null);
    
    useEffect(() => {
        navOffsetTop = navRef.current.offsetTop;
        window.onscroll = function() {
            if (window.scrollY > navOffsetTop) {
                navRef.current.classList.add("fixed");
            } else {
                navRef.current.classList.remove("fixed");
            }
        }
    }, [navRef])

    const toggleHamburger = () => {
        if (hamburgerRef.current.checkVisibility()) {
            navRef.current.classList.toggle("open");
        }
    };
    
    const clickMe = ({target}) => {

        const activeItem = navRef.current.querySelector("li.active");
        if (activeItem) {
            activeItem.classList.remove("active");
        }

        if (target.closest("li")) {
            target.closest("li").classList.add("active");
            toggleHamburger();
        }
    };

    return (
        <>
            <div className="hamburger" onClick={toggleHamburger} ref={hamburgerRef}>M</div>
            <div id="navigation" ref={navRef}>
                <ul className="navbar-new container-lg" onClick={clickMe}>

                    {data && Object.keys(data).map((key, i) => (
                        <li key={key} className={i==0 ? 'active' : ''}><a href={`#${key}-nav`}>{data[key].title.rendered}</a></li>
                    ))}

                </ul>
            </div>
        </>
    );
}

export default Navigation; 